import { useTranslation } from 'react-i18next';
import { hasActiveInstantPayDivision } from '@/enterprise/data/instantPayEnrollment';
import useTakerMarkets from '@/enterprise/data/useTakerMarkets';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import SubstitutionRecordsView from './SubstitutionRecords/SubstitutionRecordsView';

const InstantPaySubstitutionRecords = () => {
  const { t } = useTranslation();
  const { data: hasActiveDivision } = useTakerMarkets(hasActiveInstantPayDivision);

  // InstantPayLayout has already checked the flags, so send suppliers with no live division
  // back to the Instant Pay landing page rather than out of Instant Pay entirely.
  if (!hasActiveDivision) {
    return <NavigateWithRedirect to={asEnterpriseLink('instant-pay')} />;
  }

  return (
    // Spacing matches ConsolidatedHistoryLayout (Early Pay History).
    <div className="space-y-6">
      <h1 className="m-0 pb-4 font-serif text-4xl text-text-primary">{t('instantPay.substitutions.title')}</h1>
      <SubstitutionRecordsView />
    </div>
  );
};

export default InstantPaySubstitutionRecords;
